export default __webpack_public_path__ + "static/media/slider2.94e6b910.jpg";